import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import "./bookings.scss";

function BookingsList() {
  const navigate = useNavigate();
  const [bookings, setBookings] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const breadcrumbItems = [
    { title: "Bookings", link: "#" },
    { title: "Booking List", link: "#" },
  ];

  React.useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/bookings`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("bookings data:", data);

      if (Array.isArray(data)) {
        setBookings(data);
      } else if (Array.isArray(data.bookings)) {
        setBookings(data.bookings);
      } else if (data.data && Array.isArray(data.data)) {
        setBookings(data.data);
      } else {
        console.warn("Unexpected data format:", data);
        setBookings([]);
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setError(error.message);
      setBookings([]);
    } finally {
      setLoading(false);
    }
  };

  const handleViewBooking = (bookingId) => {
    // ✅ Send the booking ID through URL
    navigate(`/view-booking/${bookingId}`);
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center">Loading bookings...</div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center text-danger">Error: {error}</div>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Booking List" breadcrumbItems={breadcrumbItems} />

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table table-centered table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Customer Name</th>
                        <th>Tour Name</th>
                        <th>From Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {bookings.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No bookings found.
                          </td>
                        </tr>
                      ) : (
                        bookings.map((booking, index) => (
                          <tr key={booking._id || index}>
                            <td>{booking._id}</td>
                            <td>{booking.customer_name || "N/A"}</td>
                            <td>{booking.tour?.tour_name || "N/A"}</td>
                            <td>
                              {booking.from_date
                                ? new Date(booking.from_date).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>{booking.status || "Pending"}</td>
                            <td>
                              <button
                                className="tour-action-buttons text-primary"
                                title="View Booking"
                                onClick={() => handleViewBooking(booking._id)}
                              >
                                <i className="ri-eye-fill"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BookingsList;
